import React from "react";
import PropTypes from "prop-types";
import SFDatePicker, { SFDateRangePicker } from "../../datePicker";

const DateField = ({ operator, value, handleOnChange }) => {
  if (operator === "between") {
    // props.value is a stringified array of two date strings so we need to parse it to get the array of two date strings.
    const parsedValue = value ? JSON.parse(value) : ["", ""];
    // dateObj is an object with dateFrom and dateTo keys. The values of these keys are date strings or null.
    // This is the format that SFDateRangePicker expects.
    const dateObj = {
      dateFrom: parsedValue[0] !== "" ? parsedValue[0] : null,
      dateTo: parsedValue[1] !== "" ? parsedValue[1] : null,
    };
    // onChange converts the dateObj to an array of two date strings and stringifies it before passing it to props.handleOnChange.
    const onChange = (dateObj) => {
      const dateArr = Object.values(dateObj);
      handleOnChange(JSON.stringify(dateArr.map((x) => (x === null ? "" : x)))); // We need to convert null values to empty strings because the text field becomes red when it has a null value.
      // For example, {dateFrom: "2021-01-01T00:00:00", dateTo: "2021-01-31T00:00:00"} will be converted to ["2021-01-01T00:00:00", "2021-01-31T00:00:00"]
      // and then stringified to "[\"2021-01-01T00:00:00\",\"2021-01-31T00:00:00\"]".
    };
    return (
      <SFDateRangePicker
        values={dateObj}
        onChange={onChange}
        preventUserInput
        format="DD-MMM-YYYY"
        disableClear
      />
    );
  } else {
    return (
      <SFDatePicker
        value={value !== "" ? value : null}
        onChange={(dateStr) => {
          handleOnChange(dateStr);
        }}
        preventUserInput
        format="DD-MMM-YYYY"
        disableClear
      />
    );
  }
};

DateField.propTypes = {
  operator: PropTypes.oneOf(["=", "<", ">", "between"]),
  value: PropTypes.string.isRequired,
  handleOnChange: PropTypes.func.isRequired,
};

export default DateField;
